// extracted by mini-css-extract-plugin
export default {"container":"XiJkP","containerFullHeight":"hkeB0","body":"CyS4i","header":"Ey6Di","title":"vA7Ma","actions":"O5Nuy"};